export const CIAM_USER_NOT_FOUND = "IAM011";
export const CIAM_USER_EXIST = "IAM010";
